import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import EmployeeDetailCard from 'components/Organisms/Employee/EmployeeRecord/ActionList/EmployeeDetailCard';
import StartEndDateForm from 'components/Organisms/Employee/EmployeeRecord/ActionList/StartEndDateForm';

const ExtendProbation = ({
  label,
  btnLabel,
  employeeData,
  handleSubmit,
  handleCancel,
  loading,
  effectiveStartDate,
}) => {
  return (
    <>
      <EmployeeDetailCard employeeData={employeeData} />
      <Box mt={2}>
        <StartEndDateForm
          heading="**Please specify any probation notes as needed below."
          label={label}
          btnLabel={btnLabel}
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
          loading={loading}
          effectiveStartDate={effectiveStartDate}
        />
      </Box>
    </>
  );
};

ExtendProbation.defaultProps = {
  label: 'Probation Extention',
  btnLabel: 'Extend Probation',
  employeeData: {},
  handleSubmit: () => {},
  handleCancel: () => {},
  loading: false,
  effectiveStartDate: '',
};

ExtendProbation.propTypes = {
  label: PropTypes.string,
  btnLabel: PropTypes.string,
  employeeData: PropTypes.shape(),
  handleSubmit: PropTypes.func,
  handleCancel: PropTypes.func,
  loading: PropTypes.bool,
  effectiveStartDate: PropTypes.string,
};

export default ExtendProbation;
